import { i18n as i18nType } from 'i18next'

import accountSettings, { AccountSettingsKeys } from './accountSettings'
import accountHome, { AccountHomeKeys } from './accountHome'
import authRepGenerator, { AuthRepKeys } from './authRep'
import claims, { ClaimsKeys } from './claims'
import downloadMyData, { DownloadMyDataKeys } from './downloadMyData'
import mcf, { MCFKeys } from './mcf'
import preventiveServices, {
  preventiveServicesKeys
} from './preventiveServices'
import rxDrugCard, { RxDrugCardKeys } from './rxDrugCard'
import connectedApps, { ConnectedAppsKeys } from './connectedApps'
import premiumsEasyPay, { premiumsEasyPayKeys } from './premiumsEasyPay'
import premiumsMakeAPayment, { premiumsMakeAPaymentKeys } from './premiumsMakeAPayment'
import { useTranslation } from 'react-i18next'
import premiumBillsGenerator, { PremiumBillsKeys } from './premiumBills'
import premiumMonthlyGenerator, { PremiumMonthlyKeys } from './premiumMonthly'
import premiumHistoryGenerator, { PremiumHistoryKeys } from './premiumsHistory'
import premiumsLanding, { premiumsLandingKeys } from './premiumsLanding'

export interface GeneratorArgs {
  i18n: i18nType
}

export type LinkClickFireEvent = ({ linkUrl }: { linkUrl: string }) => void

export type FullEventMapKeys =
  | AccountSettingsKeys
  | AuthRepKeys
  | ClaimsKeys
  | DownloadMyDataKeys
  | MCFKeys
  | preventiveServicesKeys
  | AccountHomeKeys
  | RxDrugCardKeys
  | ConnectedAppsKeys
  | premiumsEasyPayKeys
  | premiumsMakeAPaymentKeys
  | PremiumBillsKeys
  | PremiumMonthlyKeys
  | PremiumHistoryKeys
  | premiumsLandingKeys

export const generateEventMap = ({ i18n }: GeneratorArgs) => {
  return {
    accountSettings: accountSettings({ i18n }),
    accountHome: accountHome({ i18n }),
    authRep: authRepGenerator({ i18n }),
    claims: claims({ i18n }),
    downloadMyData: downloadMyData({ i18n }),
    mcf: mcf({ i18n }),
    preventiveServices: preventiveServices({ i18n }),
    rxDrugCard: rxDrugCard({ i18n }),
    connectedApps: connectedApps({ i18n }),
    premiumsEasyPay: premiumsEasyPay({ i18n }),
    premiumsMakeAPayment: premiumsMakeAPayment({ i18n }),
    premiumBills: premiumBillsGenerator({ i18n }),
    premiumMonthly: premiumMonthlyGenerator({ i18n }),
    premiumsHistory: premiumHistoryGenerator({ i18n }),
    premiumsLanding: premiumsLanding({ i18n })
  }
}

export type SpecificEventMap = ReturnType<typeof generateEventMap>

// UseGeneratorArgs - this hook is called and provides the arguments for the event map generator for fields that will change during the app's runtime
export const useGeneratorArgs = (): GeneratorArgs => {
  const { i18n } = useTranslation()
  return {
    i18n
  }
}
